import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Rule, RuleDialogData } from 'src/app/models';




@Component({
  selector: 'app-rule-tree-dialog',
  templateUrl: './rule-tree-dialog.component.html',
  styleUrls: ['./rule-tree-dialog.component.css']
})
export class RuleTreeDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<RuleTreeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RuleDialogData
  ) { }

  ngOnInit(): void {
  }

  ruleSelected($event: Rule) {
    this.data.ruleSelected$.next($event);
    this.dialogRef.close();
  }
}
